export const scWalletBasic = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'erc20', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'tokenAmt', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogDeposit',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'erc20', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'tokenAmt', type: 'uint256' },
			{ indexed: true, internalType: 'address', name: 'from', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogDepositFrom',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'erc20', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'tokenAmt', type: 'uint256' },
			{ indexed: true, internalType: 'address', name: 'to', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogWithdraw',
		type: 'event'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'token', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'deposit',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'token', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'address', name: 'from', type: 'address' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'depositFrom',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'name',
		outputs: [{ internalType: 'string', name: '', type: 'string' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'token', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'address payable', name: 'to', type: 'address' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'withdraw',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	}
];
